import { mapGetters } from "vuex";
import { interfaceT } from "@/utils/interfaceTranslationFallbacks";
import {
    isBannerDismissed,
    dismissBanner,
    ensureAnalyticsUser,
    trackBannerView,
    trackBannerClickAndGo,
} from "@/utils/migrationBanner";

export default {
    name: "migration-banner",
    data() {
        return {
            show: false,
            observer: null,
        };
    },
    computed: {
        ...mapGetters({
            user: "user/user",
        }),
        headingLabel() {
            return interfaceT(this, "migrationBannerHeading");
        },
        ctaLabel() {
            return interfaceT(this, "migrationBannerCta");
        },
        closeLabel() {
            return interfaceT(this, "migrationBannerClose");
        },
        subtextLabel() {
            return interfaceT(this, "migrationBannerSubtext");
        },
    },
    mounted() {
        if (isBannerDismissed()) {
            this.show = false;

            return;
        }

        this.show = true;

        // Set user_id now if the profile is already loaded (the watcher below
        // covers the case where it arrives later).
        this.applyAnalyticsUser();

        this.$nextTick(() => {
            this.setupObserver();
        });
    },
    beforeDestroy() {
        this.teardownObserver();
    },
    watch: {
        // The user profile loads asynchronously; set user_id as soon as it is
        // available so the view/click events can be attributed.
        user() {
            this.applyAnalyticsUser();
        },
    },
    methods: {
        applyAnalyticsUser() {
            // Idempotent: setAnalyticsUserId no-ops when a user_id is already
            // present (never passes an email — the internal student id only).
            if (this.show && this.user && this.user.id) {
                ensureAnalyticsUser(this.user.id);
            }
        },
        setupObserver() {
            const el = this.$refs.banner;

            if (!el) {
                return;
            }

            if (typeof IntersectionObserver === "undefined") {
                // No IO support: the banner is a fixed on-screen card, so treat
                // it as visible and fire the (session-guarded) view event.
                trackBannerView();

                return;
            }

            this.observer = new IntersectionObserver(
                (entries) => {
                    entries.forEach((entry) => {
                        if (entry.isIntersecting) {
                            trackBannerView();
                            this.teardownObserver();
                        }
                    });
                },
                { threshold: 0.5 }
            );

            this.observer.observe(el);
        },
        teardownObserver() {
            if (this.observer) {
                this.observer.disconnect();
                this.observer = null;
            }
        },
        goToNewDesign() {
            trackBannerClickAndGo(this.user && this.user.id);
        },
        dismiss() {
            dismissBanner();
            this.show = false;
            this.teardownObserver();
        },
    },
};
